<template>
  <div class="popup-window-center">
    <!--    Popups-->
    <DocumentsPopup
      v-if="showDocumentsPopup && permissionNotesManagementPackageComputed"
      v-on:close="closeDocumentsPopupFunc"
      :record-id="documentPopupId"
      :record-type="constants.recordType.Notes"
    ></DocumentsPopup>
    <!--    End Popups-->
    <div class="popup-body notes-popup">
      <div class="card card-small notes-popup__card">
        <div class="card-header notes-popup__header">
          <div class="notes-popup__title">
            <span class="material-icons">sticky_note_2</span>
            {{ $t("general.notes.notes") }}
          </div>
          <button type="button" class="notes-popup__close" @click="close">
            <span class="material-icons">close</span>
          </button>
        </div>

        <div class="card-body notes-popup__body">
          <div class="notes-popup__composer">
              <input
                v-model="newNoteObj.noteText"
                :placeholder="$t('general.notes.noteText')"
                @keyup.enter="addNewNote"
                class="form-control d-input-style"
              />
              <d-button class="btn-with-icon notes-popup__add" :disabled="!newNoteObj.noteText.trim()" @click="addNewNote">
                <span class="material-icons">add</span>
              </d-button>
          </div>
          <div v-if="notesLst.length" class="content-container-overflow">
            <table class="table table-striped-custom table-hover-custom mb-0">
              <thead class="bg-light">
                <tr>
                  <th scope="col" class="border-0" width="40%">{{ $t("general.notes.note") }}</th>
                  <th v-if="permissionNotesManagementPackageComputed" scope="col" class="border-0 menu-cell"></th>
                  <th scope="col"
                      class="border-0"
                      width="40%"
                      @click="headerClick(true)">
                    <span class="header-style">{{ $t("general.notes.dateAdded") }}</span>
                    <span
                    v-if="showSortIconDateCreated && dateCreateClicked"
                    class="material-icons sort-icon sort-icon-color"
                    >
                      sort
                    </span>
                    <span
                      v-if="!showSortIconDateCreated && dateCreateClicked"
                      class="material-icons toggleUpDown sort-icon sort-icon-color"
                    >
                      sort
                    </span>
                  </th>
                  <th scope="col" class="border-0" width="40%">{{ $t("general.notes.createdBy") }}</th>
                  <th scope="col" class="border-0 menu-cell"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="note in notesLst" :key="note.id">
                  <td>{{ note.noteText }}</td>
                  <td v-if="permissionNotesManagementPackageComputed">
                    <span
                    @click="showDocumentsPopupFunc(note.id)"
                    class="link link-secondary link-hover d-flex align-items-center justify-content-end"
                    >
                    <span class="material-icons"> file_present </span>
                    {{ $t("general.notes.documents") }}</span
                    >
                  </td>
                  <td>{{ formatDate(note.dateCreated) }}</td>
                  <td>{{ note.creatorName }}</td>
                  <td>
                    <span
                      class="link link-secondary link-hover d-flex align-items-center justify-content-end"
                      @click="removeNote(note.id)"
                    >
                      <span class="material-icons">delete</span>
                      {{ $t("general.notes.remove") }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="!notesLst.length" class="notes-popup__empty">
            <span class="material-icons">notes</span>
            <span>{{ $t("general.notes.notes") }}</span>
          </div>
          <div class="notes-popup__footer">
            <button type="button" class="notes-popup__cancel" @click="close">
              {{ $t("general.notes.close") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DocumentsPopup from '@/components/General/Documents/DocumentsPopup';
import constants from '@/utils/constants';
import notesService from '@/services/notes.service';

export default {
  name: 'NotesPopup',
  components: { DocumentsPopup },
  props: {
    recordId: {
      required: true,
      type: [Number, String],
    },
    recordType: {
      required: true,
      type: Object,
      default() {
        return {
          entity: '',
          fieldName: '',
        };
      },
    },
  },
  data() {
    return {
      constants,
      notesLst: [],

      showDocumentsPopup: false,
      documentPopupId: undefined,

      dateCreateClicked: false,
      showSortIconDateCreated: true,

      newNoteObj: {
        id: 0,
        createdBy: 0,
        lastModifiedBy: 0,
        dateCreated: '',
        dateModified: '',
        referenceMemberId: 0,
        referenceMembershipId: 0,
        referenceTaskId: 0,
        referencePaymentId: 0,
        referenceExpenseId: 0,
        referenceProductId: 0,
        referenceProductTransactionId: 0,
        referenceSaleId: 0,
        noteText: '',
      },

      orderBy: 'DateCreated',
      orderDir: 'desc',
    };
  },
  created() {
    this.getNotes();
    this.newNoteObj[this.recordType.fieldNameForObject] = this.recordId;
  },
  methods: {
    async getNotes(orderBy = 'DateCreated', orderDir = 'desc', paged = false) {
      this.$store.commit('changeShowLoader', true);

      if (orderBy !== 'DateCreated') {
        this.showSortIconDateCreated = true;
      }

      if (!paged) {
        this.currentPage = 1;

        if (orderBy === 'DateCreated') {
          if (orderDir === 'desc') {
            this.showSortIconDateCreated = true;
          } else {
            this.showSortIconDateCreated = false;
          }
        }
      }

      await notesService.list({
        [this.recordType.fieldName]: this.recordId,
        orderBy,
        orderDir,
      })
        .then((data) => {
          if (data) {
            this.notesLst = data.data;
          } else {
            throw 'Server return status false';
          }
        })
        .catch((err) => {
          this.showError(err, this.$t('errors.entities.notes'), 'load');
        });
      this.$store.commit('changeShowLoader', false);
    },
    onPageChange(page) {
      this.currentPage = page;
      this.getNotes(this.orderBy, this.orderDir, true);
    },
    headerClick(dateCreated = false) {
      this.dateCreateClicked = dateCreated;

      if (this.showSortIconDateCreated && dateCreated) {
        this.getNotes('DateCreated', 'asc');
      } else if (!this.showSortIconDateCreated && dateCreated) {
        this.getNotes('DateCreated', 'desc');
      }
    },
    async removeNote(noteId) {
      this.$confirm(this.$t('general.notes.deletionConfirmation'), undefined, undefined, {
        confirmButtonText: this.$t('generalMessages.Ok'),
        cancelButtonText: this.$t('generalMessages.cancel'),
      }).then(async () => {
        this.$store.commit('changeShowLoader', true);
        await notesService.remove(noteId)
          .then((data) => {
            if (data) {
              this.$toast.success(this.$t('general.notes.deletedSuccessfully'));
              this.getNotes();
            } else {
              throw 'Server return status false';
            }
          })
          .catch((err) => {
            this.showError(err, this.$t('errors.entities.note'), 'delete');
          });
        this.$store.commit('changeShowLoader', false);
      });
    },
    async addNewNote() {
      if (this.newNoteObj.noteText !== '') {
        this.$store.commit('changeShowLoader', true);
        const noteObj = this.cleanEmptyAttrFromObj(this.newNoteObj);
        await notesService.create(noteObj)
          .then((data) => {
            if (data) {
              this.$toast.success(this.$t('general.notes.addedSccessfully'));
              this.getNotes();
              this.newNoteObj.noteText = '';
            } else {
              throw 'Server return status false';
            }
          })
          .catch((err) => {
            this.showError(err, this.$t('errors.entities.note'), 'save');
          });

        this.$store.commit('changeShowLoader', false);
      }
    },
    close() {
      this.$emit('close');
    },

    async showDocumentsPopupFunc(itemId) {
      setTimeout(() => {
        this.showDocumentsPopup = true;
        this.documentPopupId = itemId;
      }, 50);
    },
    async closeDocumentsPopupFunc() {
      this.showDocumentsPopup = false;
      this.documentPopupId = undefined;
    },
  },
  computed: {
    permissionNotesManagementPackageComputed() {
      return this.hasFeature('follow-ups');
    },
  },
};
</script>

<style scoped>
.notes-popup {
  width: min(920px, calc(100vw - 32px));
}

.notes-popup__card {
  border: 0;
  border-radius: 16px;
  box-shadow: 0 22px 64px rgba(24, 45, 66, .24);
  margin: 0 !important;
  overflow: hidden;
}

.notes-popup__header {
  align-items: center;
  background: #fff;
  border-bottom: 1px solid var(--fitnet-surface-border-color, #e5ecf2);
  display: flex;
  justify-content: space-between;
  padding: 18px 20px;
}

.notes-popup__title {
  align-items: center;
  color: var(--fitnet-heading-color);
  display: flex;
  font-size: 1.15rem;
  font-weight: 700;
  gap: 9px;
}

.notes-popup__title .material-icons {
  color: var(--fitnet-primary);
  font-size: 22px;
}

.notes-popup__close {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fitnet-muted-text-color);
  display: inline-flex;
  height: 36px;
  justify-content: center;
  width: 36px;
}

.notes-popup__close:hover,
.notes-popup__close:focus {
  background: rgba(0, 152, 184, .09);
  color: var(--fitnet-primary);
}

.notes-popup__body {
  padding: 20px;
}

.notes-popup__composer {
  display: grid;
  gap: 9px;
  grid-template-columns: minmax(0, 1fr) 42px;
  margin-bottom: 18px;
}

.notes-popup__composer .form-control {
  border-color: var(--fitnet-surface-border-color, #dce5ed);
  border-radius: 9px;
  height: 42px;
}

.notes-popup__composer .form-control:focus {
  border-color: var(--fitnet-primary);
  box-shadow: 0 0 0 3px rgba(0, 152, 184, .1);
}

.notes-popup__add {
  border-radius: 9px;
  height: 42px;
  padding: 0 !important;
  width: 42px;
}

.content-container-overflow {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid var(--fitnet-surface-border-color, #e5ecf2);
  border-radius: 10px;
}

.content-container-overflow .table th {
  background: #f6fafc;
  color: var(--fitnet-heading-color);
  font-size: .75rem;
  font-weight: 700;
}

.content-container-overflow .table td {
  color: var(--fitnet-text-color);
  vertical-align: middle;
}

.notes-popup__empty {
  align-items: center;
  border: 1px dashed var(--fitnet-surface-border-color, #dce5ed);
  border-radius: 10px;
  color: var(--fitnet-muted-text-color);
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: center;
  min-height: 120px;
}

.notes-popup__empty .material-icons {
  color: #a9b8c6;
  font-size: 30px;
}

.notes-popup__footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.notes-popup__cancel {
  background: transparent;
  border: 0;
  border-radius: 7px;
  color: var(--fitnet-muted-text-color);
  padding: 7px 10px;
}

.notes-popup__cancel:hover,
.notes-popup__cancel:focus {
  background: rgba(0, 152, 184, .09);
  color: var(--fitnet-primary);
}

.button-container-relative {
  position: relative;
}

.d-input-style{
  padding: 7px 12px;
  margin: 0;
  background: #FFFFFF;
}

.sort-icon{
    cursor: pointer;
    font-size: medium;
}

.header-style{
    cursor: pointer;
}

.toggleUpDown {
    transform: rotate(180deg);
}

.sort-icon-color{
    color:  #666;
    padding-top: 2px;
    padding-right: 2px;
    padding-left: 2px;
  }

@media (max-width: 575px) {
  .notes-popup {
    width: calc(100vw - 20px);
  }
  .notes-popup__body,
  .notes-popup__header {
    padding: 14px;
  }
}
</style>
